import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { GraphicLungStyle } from './GraphicLungStyle';

const GraphicLung = ({ classification, mouseEvents }) => {
  const [active, setActive] = useState('');

  const handleMouseOver = (currentActive, parentFuncition) => {
    if (parentFuncition) {
      parentFuncition();
    }

    if (currentActive && currentActive.length) {
      setActive(currentActive);
    }
  };

  const handleMouseLeave = (parentFuncition) => {
    if (parentFuncition) {
      parentFuncition();
    }

    setActive('');
  };

  return (
    <GraphicLungStyle
      className={`classification-${classification}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 172 168"
    >
      <path
        className={`lung-part right-upper${active === 'ru' ? ' active' : ''}`}
        d="M8.37,50.71c-.59-7.33-1.7-23.87,7.81-39.14,7.51-12,15.2-16.79,31.23-3.91,20,16.16,26.33,40.06,33.46,68.21,5.25,24.12,7.82,34-11.71,25.16-12.25-5-23-13.71-36.25-15.1-5.9-.64-7.41.56-10,0C11.24,83.48,8.57,53.2,8.37,50.71Z"
        onMouseOver={() => handleMouseOver('ru', mouseEvents.ru.over)}
        onClick={() => handleMouseOver('ru', mouseEvents.ru.over)}
        onMouseLeave={() => handleMouseLeave(mouseEvents.leave)}
      />
      <path
        className={`lung-part right-middle${active === 'rm' ? ' active' : ''}`}
        d="M25.19,96.84c-7.07-19,19.32-2.15,26.29,2.24,6,3.17,11.59,6.18,19.58,7.82,4.82,1,7.63.9,9.52,3.36,2.33-.09-.58,24.59-1.12,26.27-1.06,12.73-8.2,22.44-22.94,17.89-6-2.16-11.45-16.46-13.43-24C39,119,29.23,108.74,25.19,96.84Z"
        onMouseOver={() => handleMouseOver('rm', mouseEvents.rm.over)}
        onClick={() => handleMouseOver('rm', mouseEvents.rm.over)}
        onMouseLeave={() => handleMouseLeave(mouseEvents.leave)}
      />
      <path
        className={`lung-part right-lower${active === 'rl' ? ' active' : ''}`}
        d="M2.44,72.77c-3.16,1.44-2.55,8.08-2,20.06C2.1,116.48,0,135.54,6.21,159.39c5.54,13.33,17,6.92,31,4.6,6.66-1.47,7.75-1.61,9-3,7.11-12.85-1.89-20.66-9.91-33.23-4.67-7.33-3.25-6.93-12.25-23.72-7-13-7.89-11.9-9.34-16.65C12.31,82.28,11.48,68.63,2.44,72.77Z"
        onMouseOver={() => handleMouseOver('rl', mouseEvents.rl.over)}
        onClick={() => handleMouseOver('rl', mouseEvents.rl.over)}
        onMouseLeave={() => handleMouseLeave(mouseEvents.leave)}
      />
      <path
        className={`lung-part left-upper${active === 'lu' ? ' active' : ''}`}
        d="M102.74,156.51c-5.53-4.07-1.9-14.95-.38-21.48.71-6.46.76-8-3.37-17.33-9.91-18.2-7.41-32.49-6.75-55.76-1.17-19.1,2-24.51,11.62-33.53,7.85-7.6,12.48-8.45,18-14.69,6-12.43,21.32-17.42,28.48-2.64,16.85,28.08,10.49,54.25,10.49,54.25-.57,6.19-38.81,64.61-45,81C115.12,149,109.16,158.18,102.74,156.51Z"
        onMouseOver={() => handleMouseOver('lu', mouseEvents.lu.over)}
        onClick={() => handleMouseOver('lu', mouseEvents.lu.over)}
        onMouseLeave={() => handleMouseLeave(mouseEvents.leave)}
      />
      <path
        className={`lung-part left-lower${active === 'll' ? ' active' : ''}`}
        d="M169.2,69.77c7.07,9.82-.93,64.83-5.55,86.07-5.58,21.4-40.68,10.3-45.21-1-1.64-5.71,3.24-11.72,4.9-13.84C143.06,115.92,160.64,66.44,169.2,69.77Z"
        onMouseOver={() => handleMouseOver('ll', mouseEvents.ll.over)}
        onClick={() => handleMouseOver('ll', mouseEvents.ll.over)}
        onMouseLeave={() => handleMouseLeave(mouseEvents.leave)}
      />
    </GraphicLungStyle>
  );
};

GraphicLung.propTypes = {
  classification: PropTypes.string.isRequired,
  mouseEvents: PropTypes.shape({
    ru: PropTypes.shape({ over: PropTypes.func.isRequired }).isRequired,
    rm: PropTypes.shape({ over: PropTypes.func.isRequired }).isRequired,
    rl: PropTypes.shape({ over: PropTypes.func.isRequired }).isRequired,
    lu: PropTypes.shape({ over: PropTypes.func.isRequired }).isRequired,
    ll: PropTypes.shape({ over: PropTypes.func.isRequired }).isRequired,
    leave: PropTypes.func.isRequired,
  }).isRequired,
};

export default GraphicLung;
